module.exports = __webpack_public_path__ + "media/images/plans/propose_original/proposal-sumple-3-bed4c42c983239d84c1eaf1d27784035.jpg";